// noinspection GraphQLUnresolvedReference

import { gql } from "graphql-request";

export const CUSTOM_ASSUMPTION_QUERY = gql`
    mutation ExecuteGetScenarioCustomAssumption(
        $inScenarioID: UUID!,
        $inProjectTypeID: Int!,
    ) {
        executeGetScenarioCustomAssumption(
            inScenarioID: $inScenarioID,
            inProjectTypeID: $inProjectTypeID
        ) {
            ScenarioID
            ProjectTypeID
            InvestmentPlanning
            InvestmentConstruction
            InvestmentCommissioning
            TimePlanning
            TimeConstruction
            TimeCommissioning
        }
    }
`;
export const CUSTOM_ASSUMPTION_MUTATE = gql`
    mutation ExecuteCreateScenarioCustomAssumption(
        $inScenarioID: UUID!,
        $inProjectTypeID: Int!,
        $inInvestmentPlanning: String!,
        $inInvestmentConstruction: String!,
        $inInvestmentCommissioning: String!,
        $inTimePlanning: String!,
        $inTimeConstruction: String!,
        $inTimeCommissioning: String!
    ) {
        executeCreateScenarioCustomAssumption(
            inScenarioID: $inScenarioID
            inProjectTypeID: $inProjectTypeID
            inInvestmentPlanning: $inInvestmentPlanning
            inInvestmentConstruction: $inInvestmentConstruction
            inInvestmentCommissioning: $inInvestmentCommissioning
            inTimePlanning: $inTimePlanning
            inTimeConstruction: $inTimeConstruction
            inTimeCommissioning: $inTimeCommissioning
        ) {
            result
        }
    }
`;


export const CUSTOM_ASSUMPTION_DELETE = gql`
    mutation ExecuteDeleteScenarioCustomAssumption(
        $inScenarioID: UUID!,
        $inProjectTypeID: Int!,
    ) {
        executeDeleteScenarioCustomAssumption(
            inScenarioID: $inScenarioID,
            inProjectTypeID: $inProjectTypeID
        ) {
            result
        }
    }
`;

export const RunModel = gql`
    mutation ExecuteRunScenario(
        $inScenarioID: UUID!
    ) {
        executeRunScenario(inScenarioID: $inScenarioID) {
            result
        }
    }
`;
